import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-1/2" }, null, -1)
const _hoisted_3 = { class: " mt-4 w-full inline-block relative" }
const _hoisted_4 = { class: "absolute right-0 bottom-0 mr-2 mb-2 text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_5 = {
  key: 0,
  class: "pt-3 text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-500 mt-2" }, " *Anda bisa menambahkan email lebih dari satu ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_9 = { class: "py-3 w-full mr-4 space-y-4" }
const _hoisted_10 = { class: "flex flex-row items-center gap-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DatePickers = _resolveComponent("DatePickers")!
  const _component_UploadFile = _resolveComponent("UploadFile")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_Title, { label: "Informasi Billing" }),
    _createVNode("div", {
      class: `flex justify-between gap-x-8 ${_ctx.styleWrapper}`
    }, [
      _createVNode(_component_DataWrapper, {
        label: "No. WhatsApp",
        class: "w-1/2",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectPhoneCountry, {
            phone: _ctx.form.noWhatsApp,
            code: _ctx.form.noWhatsAppDialCode || _ctx.defaultDialCode,
            error: _ctx.errorWhatsAppSelect,
            column: "Kontak",
            placeholder: "81119600999",
            onSetPhone: _ctx.onSetBillingWhatsApp,
            onSetPhoneCode: _cache[1] || (_cache[1] = v => (_ctx.form.noWhatsAppDialCode = v))
          }, null, 8, ["phone", "code", "error", "onSetPhone"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Jadwal Penagihan",
        class: "w-1/2",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Select, {
            onOpenSelect: _ctx.onOpenSelectBillingSchedule,
            onCloseSelect: _ctx.onCloseSelectBillingSchedule,
            isOpenMenu: _ctx.isOpenBillingSchedule,
            value: _ctx.form.billingSchedule,
            onChooseSelect: _ctx.onSelectBillingSchedule,
            dataSelect: _ctx.billingScheduleList,
            class: "w-full whitespace-no-wrap my-2"
          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
        ]),
        _: 1
      })
    ], 2),
    _createVNode("div", {
      class: `flex justify-between gap-x-8 ${_ctx.styleWrapper}`
    }, [
      _createVNode(_component_DataWrapper, {
        label: "Jangka Waktu Pembayaran",
        class: "w-1/2",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Select, {
            onOpenSelect: _ctx.onOpenSelectRangeTimePayment,
            onCloseSelect: _ctx.onCloseSelectRangeTimePayment,
            isOpenMenu: _ctx.isOpenRangeTimePayment,
            value: _ctx.form.timeRangePayment,
            onChooseSelect: _ctx.onSelectRangeTimePayment,
            dataSelect: _ctx.rangeTimePaymentList,
            class: "w-full whitespace-no-wrap my-2"
          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
        ]),
        _: 1
      }),
      _hoisted_2
    ], 2),
    _createVNode(_component_DataWrapper, {
      label: "Email",
      class: _ctx.styleWrapper,
      asterisk: ""
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.form.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.email = $event)),
            "tag-placeholder": "Tekan enter untuk menambah Email",
            placeholder: "Masukan Email",
            options: _ctx.options,
            maxLength: 20,
            multiple: true,
            taggable: true,
            isTextArea: "",
            "open-direction": "below",
            showNoOptions: false,
            customNoResult: "Email ini telah dimasukan",
            isError: _ctx.errorEmail
          }, null, 8, ["modelValue", "options", "isError"]),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.form.email?.length) + "/20 ", 1)
        ]),
        (_ctx.error.emailBilling)
          ? (_openBlock(), _createBlock("p", _hoisted_5, " Masukan Email dengan benar "))
          : _createCommentVNode("", true),
        _hoisted_6
      ]),
      _: 1
    }, 8, ["class"]),
    _hoisted_7,
    _createVNode(_component_Title, { label: "Perjanjian Kerjasama" }),
    _createVNode("div", {
      class: `flex justify-between gap-x-8 ${_ctx.styleWrapper}`
    }, [
      _createVNode(_component_DataWrapper, {
        label: "Dimulai Dari",
        class: "w-1/2",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DatePickers, {
            placeholder: "Tanggal mulai",
            modelValue: _ctx.form.startDate,
            onSelected: _ctx.setPeriodeStart,
            class: "my-2"
          }, null, 8, ["modelValue", "onSelected"]),
          (_ctx.error.invalidDate)
            ? (_openBlock(), _createBlock("div", _hoisted_8, " Tanggal mulai tidak boleh lebih dari tanggal akhir "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Sampai",
        class: "w-1/2",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DatePickers, {
            placeholder: "Tanggal berakhir",
            modelValue: _ctx.form.endDate,
            onSelected: _ctx.setPeriodeEnd,
            minDate: new Date(_ctx.form.startDate),
            class: "my-2",
            disabled: !_ctx.form.startDate
          }, null, 8, ["modelValue", "onSelected", "minDate", "disabled"])
        ]),
        _: 1
      })
    ], 2),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_DataWrapper, {
        label: "Berkas Lampiran",
        class: "w-full",
        asterisk: ""
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_UploadFile, {
              titleChange: "Ubah Berkas",
              onChange: _ctx.onChangeAttachment,
              name: _ctx.form.fileNameAttachment,
              url: _ctx.form.attachmentUrl,
              modelValue: _ctx.form.attachment,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.attachment = $event)),
              caption: ".pdf up to 15 MB",
              allowed: ".pdf",
              class: `${_ctx.styleWrapper} my-2`,
              maxSize: 15,
              type: "",
              isDraggable: false
            }, null, 8, ["onChange", "name", "url", "modelValue", "class"])
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}